import { render, staticRenderFns } from "./ExperimentalDesigns.vue?vue&type=template&id=3bc6f4b0&scoped=true"
import script from "./ExperimentalDesigns.vue?vue&type=script&lang=js"
export * from "./ExperimentalDesigns.vue?vue&type=script&lang=js"
import style0 from "./ExperimentalDesigns.vue?vue&type=style&index=0&id=3bc6f4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6f4b0",
  null
  
)

export default component.exports